import { ContractStageType } from '../models/Entities/Contracts/ContractStageType';
import * as CommonService from './commons/CommonService.Functions';

const BaseURL = process.env.REACT_APP_BILLER_API_GATEWAY + 'contracts/stages/types';

// Get all contract stage types
export const GetContractsStageTypes = async (token: string): Promise<ContractStageType[]> => {
    return CommonService.apiRequest<ContractStageType[]>(BaseURL, token, 'GetContractsStageTypes', { method: 'GET' });
};

// Get contract stage type by ID
export const GetContractStageTypeById = async (id: number, token: string): Promise<ContractStageType> => {
    return CommonService.apiRequest<ContractStageType>(`${BaseURL}/${id}`, token, 'GetContractStageTypeById', { method: 'GET' });
};

// Create contract stage type
export const CreateContractStageType = async (data: Partial<ContractStageType>, token: string): Promise<ContractStageType> => {
    return CommonService.apiRequest<ContractStageType>(BaseURL, token, 'CreateContractStageType', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

// Update contract stage type
export const UpdateContractStageType = async (id: number, data: Partial<ContractStageType>, token: string): Promise<ContractStageType> => {
    return CommonService.apiRequest<ContractStageType>(`${BaseURL}/${id}`, token, 'UpdateContractStageType', {
        method: 'PUT',
        body: JSON.stringify(data)
    });
};

// Delete contract stage type
export const DeleteContractStageType = async (id: number, token: string): Promise<void> => {
    return CommonService.apiRequest<void>(`${BaseURL}/${id}`, token, 'DeleteContractStageType', { method: 'DELETE' });
};